export default __webpack_public_path__ + "static/media/english-to-dutch-screenshot-06.fc7f3df0.png";